module.exports = __webpack_public_path__ + "static/media/metereologiaDisabled.f65b9df1.svg";